module.exports = "#reportNotFound {\n  text-align: center;\n  padding-top: 30px; }\n  #reportNotFound p {\n    font-family: Roboto;\n    font-size: 20px;\n    font-weight: normal;\n    font-style: normal;\n    font-stretch: normal;\n    line-height: 1.35;\n    letter-spacing: 0px;\n    text-align: center;\n    color: #939393; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/entities/energy/energy-reports/energy-reports.component.scss
// module id = ./src/app/entities/energy/energy-reports/energy-reports.component.scss
// module chunks = main